/* eslint-disable */

import axios from 'axios';

/**
 * @param {string} url The url for the file in S3 bucket.
 * @param {string} fileType image or video.
 *
 * @returns true if the url is valid and the file is accessible. Otherwise, return false.
 *
 * NOTE
 *
 * This function will check if the url is accessible and the file this url is pointing to is the right type.
 *   The general logic flows as below.
 *      1. Send head request to the url.
 *      2. If returned status code 2xx, proceed. Otherwise, return false because the url isn't accessible.
 *      3. Check content type (Content-Type: image/png) and see if it matches the fileType parameter.
 *      4. If the file types aren't match, return false. Otherwise, return true.
 */
export const validateUrl = async (url, fileType) => {
  if (!url || url === '') return false; // return if url is not valid or empty since there no point of sending head request.

  const allowedImageTypes = ['png', 'jpg', 'jpeg', 'gif'];
  const allowedVideoTypes = ['mp4'];

  // const contentType = await getContentType(url); // Disabling this. There was weired issue in chrome where some of the old files throwing CORS error while newer files work.

  const contentType = getFileExtension(url);

  if (!contentType || contentType === '') return false;

  switch (fileType.toLowerCase()) {
    case 'image':
      return allowedImageTypes.indexOf(contentType.toLowerCase()) > -1;

    case 'video':
      return allowedVideoTypes.indexOf(contentType.toLowerCase()) > -1;

    default:
      throw new Error('Unknown file type passed into validator.');
  }
};

/**
 * @param {string} url The url for the file in S3 bucket.
 * @return null if head request failed, headers is empty or the headers does not contain content-type.
 */
const getContentType = async (url) => {
  const response = await axios.head(url);

  if (!response || response.status >= 300 || !response.headers) return null;

  const { headers } = response;

  if (!headers || !headers['content-type']) return null;

  return `${headers['content-type'].split('/').slice(-1)}`; // image/png,jpg,jpeg,gif or video/mp4
};

const getFileExtension = (url) => {
  const splitted = url.split('.');
  const extension = splitted ? splitted.slice(-1) : [];

  return `${extension}`;
};



// WEBPACK FOOTER //
// ./src/utils/validators.js